import { Center, Spinner } from "@chakra-ui/react";
import { buildDataHandlerInfiniteComponent } from "@raiden/library/components/DataHandlerInfinite";
import { apiGetErrorDetail } from "@raiden/library/helpers/api";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useIntl } from "react-intl";
import { Splash } from "../Splash";

function SplashNoResult() {
  const intl = useIntl();

  return (
    <Splash
      src={generateFrontPath({
        id: "@front.internal-assets",
        parameters: { filePath: "illustrations/not-found.svg" },
      })}
      title={intl.formatMessage({ defaultMessage: "Aucun résultat" })}
      description={intl.formatMessage({
        defaultMessage:
          "Nous sommes désolés, aucun résultat de correspond à votre recherche.",
      })}
    />
  );
}

/**
 * @param {object} params
 * @param {import('@raiden/library/types/Api/ApiError').ApiError} params.error
 */
function SplashError({ error }) {
  const intl = useIntl();

  return (
    <Splash
      src={generateFrontPath({
        id: "@front.internal-assets",
        parameters: { filePath: "illustrations/error.svg" },
      })}
      title={intl.formatMessage({
        defaultMessage: "Une erreur est survenue",
      })}
      description={apiGetErrorDetail({ error })}
    />
  );
}

const loadingElement = (
  <Center>
    <Spinner size="lg" />
  </Center>
);

export const DataHandlerInfinite = buildDataHandlerInfiniteComponent({
  SplashNoResult,
  SplashError,
  loadingElement,
});
